/** Created by azhou on 2019/3/27.*/
<template>
    <div>
      <div class="d-center-between mb-3">
        <div class="d-center-start w-50 mr-2">
          <left-text leftText="原注册人"/>{{BasicInfo.contact}}
        </div>
        <div class="d-center-start w-50 ml-2">
          <left-text leftText="原注册人电话"/>{{BasicInfo.mob}}
        </div>
      </div>
      <div class="d-center-between mb-3" v-if="storeInfo.type!==2">
        <div class="d-center-start w-50 mr-2">
          <left-text leftText="签约身份"/>
          <el-select v-model="BasicInfo.contract" class="w-100">
            <el-option v-for="item in StoreBasicInfo.contractList"
                       :key="item.id"
                       :label="`${item.title}-佣金：${item.yongjin}`"
                       :value="item.id" />
          </el-select>
        </div>
        <left-text-border class="w-50 ml-2" leftText="门店权重" v-model="BasicInfo.rank"/>
      </div>
      <div class="d-center-between mb-3">
        <div class="d-center-start w-50 mr-2">
          <left-text leftText="对接人"/>
          <el-select v-model="BasicInfo.person_liable_id" class="w-100">
            <el-option v-for="item in StoreBasicInfo.adminList"
                       :key="item.id"
                       :label="item.truename"
                       :value="item.id" />
          </el-select>
        </div>
        <div class="d-center-start w-50  ml-2">
          <left-text leftText="是否显示"/>
          <el-radio v-model="BasicInfo.display" label="1">是</el-radio>
          <el-radio v-model="BasicInfo.display" label="0">否</el-radio>
        </div>
      </div>
      <div class="d-start-start">
        <left-text leftText="签约合同"/>
        <upload-file @fileChange="fileChange"
                      :existImgs="BasicInfo.contract_pic" :maxLength="99" editMode/>
      </div>     
    </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'AdminSet',
    computed: {
      ...mapState(['StoreBasicInfo']),
      ...mapGetters(['storeInfo','isAdmin'])
    },
    data () {
      return {
        BasicInfo: {},
        contract_pic:[]
      }
    },
    watch: {
      StoreBasicInfo () {
        this.initStoreInfo()
      },
    },
    created () {
      this.initStoreInfo()
    },
    methods:{
      /*门店信息初始化*/
      initStoreInfo() {
        this.BasicInfo = {
          ...this.StoreBasicInfo,
          display:this.StoreBasicInfo.display + '',
          contract:this.StoreBasicInfo.contract > 0 ? this.StoreBasicInfo.contract*1 : '',
          person_liable_id:this.StoreBasicInfo.person_liable_id > 0 ? this.StoreBasicInfo.person_liable_id*1 : '',
          contract_pic:this.StoreBasicInfo.contract_pic&&this.StoreBasicInfo.contract_pic.split(',')
        };
        // if(this.BasicInfo.contract_pic)this.contract_pic = this.BasicInfo.contract_pic.split(',')
      },

      fileChange(imgs){
        this.contract_pic = Array.from([...imgs]);
      },
    }
  }
</script>
